module.exports = __webpack_public_path__ + "media/images/help/authentication-5204df7d428320dcf6169cf4f7ae1cf4.png";